import { render, staticRenderFns } from "./CustomUnits.vue?vue&type=template&id=5d4db61f&scoped=true&"
import script from "./CustomUnits.vue?vue&type=script&lang=js&"
export * from "./CustomUnits.vue?vue&type=script&lang=js&"
import style0 from "./CustomUnits.vue?vue&type=style&index=0&id=5d4db61f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4db61f",
  null
  
)

export default component.exports